/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `file_creator` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class FileCreatorMesg : Mesg {
    public constructor() : super("FileCreator", Profile.MesgNum.FILE_CREATOR)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** software_version. */
    public var softwareVersion: UShort?
        get() = getFieldValue(SOFTWARE_VERSION_FIELD_NUM) as? UShort
        set(value) = setFieldValue(SOFTWARE_VERSION_FIELD_NUM, value)

    /** hardware_version. */
    public var hardwareVersion: UByte?
        get() = getFieldValue(HARDWARE_VERSION_FIELD_NUM) as? UByte
        set(value) = setFieldValue(HARDWARE_VERSION_FIELD_NUM, value)

    public companion object {
        public const val SOFTWARE_VERSION_FIELD_NUM: UByte = 0u
        public const val HARDWARE_VERSION_FIELD_NUM: UByte = 1u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("SoftwareVersion", 0u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[1] = Field("HardwareVersion", 1u, BaseType.UINT8, 1.0, 0.0, "", false)
            return fields
        }
    }
}
